import React from 'react';
import { connect } from 'react-redux';

import { endSession } from 'actions/session';

import AppRouter from './AppRouter';
import NavBar from './NavBarContainer';
import { Form1Notice } from './Notices';
import SnackBar from 'components/common/SnackBar';

export const AppContainer = ({ beta, dispatchEndSession, user, isAuth }) => {
  return (
    <React.Fragment>
      <AppRouter
        beta={beta}
        user={user}
        isAuth={isAuth}
        notices={[<Form1Notice key="FORM_1_NOTICE" />]}
        appBar={isAuth && <NavBar user={user} onLogoutClick={dispatchEndSession} />}
      />
      <SnackBar />
    </React.Fragment>
  );
};

const mapStateToProps = ({ session }) => ({
  beta: session.account && session.account.form1_beta,
  isAuth: session.isAuth,
  user: {
    businessName: session.business_name,
    emailAddress: session.email_address,
    userName: `${session.first_name} ${session.last_name}`,
  },
});

const mapDispatchToProps = {
  dispatchEndSession: endSession,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);
